import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FocusedJourneyLayout, MaskContainer, MaskContext, MaskHeadline,
  MaskInput, MaskTextarea, PrimaryAction, SecondaryAction, MaskBack, MaskClose,
} from '@/components/mask/MaskSystem';

/* Phase 1 — isolierter Preview des Mask Systems. Sendet NICHTS, ersetzt NICHTS. */

const BEISPIEL_PERSONEN = ['Anna', 'Jonas', 'Deine Oma'];

export default function MaskPreviewV2() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [person, setPerson] = useState('');
  const [text, setText] = useState('');

  const close = () => navigate('/inbox');
  const choosePerson = (name) => { setPerson(name); setStep(2); };

  return (
    <FocusedJourneyLayout>
      <MaskClose onClick={close} data-testid="mask-close-btn" />
      {step > 0 && <MaskBack onClick={() => setStep(step - 1)} data-testid="mask-back-btn" />}

      {step === 0 && (
        <MaskContainer maskKey="m0" bgWord="WAHRNEHMEN" align="center" bgShift="-10%">
          <MaskContext>Ein Moment für Dich</MaskContext>
          <MaskHeadline>An wen denkst Du gerade?</MaskHeadline>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-3">
            <PrimaryAction onClick={() => setStep(1)} data-testid="mask-step0-primary">Ich habe jemanden im Kopf</PrimaryAction>
            <SecondaryAction onClick={close} data-testid="mask-step0-secondary">Vielleicht später</SecondaryAction>
          </div>
        </MaskContainer>
      )}

      {step === 1 && (
        <MaskContainer maskKey="m1" bgWord="DU" bgPosition="top" bgShift="18%">
          <MaskHeadline>Wem möchtest Du etwas sagen?</MaskHeadline>
          <MaskInput
            autoFocus
            value={person}
            onChange={(e) => setPerson(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && person.trim()) setStep(2); }}
            placeholder="Ein Name genügt …"
            data-testid="mask-person-input"
          />
          <div className="mask-enter mask-enter-delay-3 mt-10 space-y-1">
            {BEISPIEL_PERSONEN.map((name) => (
              <button
                key={name}
                type="button"
                onClick={() => choosePerson(name)}
                data-testid={`mask-person-${name}`}
                className="mask-person-row block w-full text-left text-lg text-[var(--text)]/80 py-3 px-3 rounded-lg"
              >
                {name}
              </button>
            ))}
          </div>
        </MaskContainer>
      )}

      {step === 2 && (
        <MaskContainer maskKey="m2" bgWord="AUSSPRECHEN" bgPosition="bottom" bgShift="-14%">
          {person.trim() && <MaskContext>Für {person.trim()}</MaskContext>}
          <MaskHeadline>Was möchtest Du diesem Menschen sagen?</MaskHeadline>
          <MaskTextarea
            autoFocus
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Schreib es so, wie Du es sagen würdest. Ein ehrlicher Satz genügt."
            data-testid="mask-message-textarea"
          />
          <div className="mt-8">
            <PrimaryAction onClick={() => setStep(3)} disabled={!text.trim()} data-testid="mask-step2-primary">Aussprechen</PrimaryAction>
          </div>
        </MaskContainer>
      )}

      {step === 3 && (
        <MaskContainer maskKey="m3" bgWord="ANGEKOMMEN" align="center" bgShift="-8%">
          {person.trim() && <MaskContext>Für {person.trim()}</MaskContext>}
          <MaskHeadline>Deine Worte sind bereit.</MaskHeadline>
          <p className="mask-enter mask-enter-delay-2 text-base text-[var(--muted)] leading-relaxed mb-10 max-w-md">
            So wird sich das neue CarmaCircle anfühlen: ruhig, bewusst, ein Gedanke nach dem anderen.
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-3">
            <PrimaryAction onClick={() => { setStep(0); setPerson(''); setText(''); }} data-testid="mask-step3-primary">Noch einmal erleben</PrimaryAction>
            <SecondaryAction onClick={close} data-testid="mask-step3-secondary">Preview verlassen</SecondaryAction>
          </div>
        </MaskContainer>
      )}
    </FocusedJourneyLayout>
  );
}
